let Api = {
  KY_BIGDATA_BASIC_FINDLIST : "/simple-api/w/ky/bigdata/basic/findList", // 牛业产业链列表
  KY_BIGDATA_BASIC_UPDATELIST : "/simple-api/w/ky/bigdata/basic/updateList", // 牛业产业链修改
  KY_BIGDATA_BREED_FINDLIST : "/simple-api/w/ky/bigdata/breed/findList", // 牛业养殖列表
  KY_BIGDATA_BREED_UPDATELIST : "/simple-api/w/ky/bigdata/breed/updateList", // 牛业养殖列表修改
  KY_BIGDATA_BREED_BRANDPAGELIST : "/simple-api/w/ky/bigdata/brand/brandPageList", // 品牌分页列表
  KY_BIGDATA_BREED_SAVEORUPDATE : "/simple-api/w/ky/bigdata/brand/saveOrUpdate", // 品牌新增修改
  KY_BIGDATA_BREED_FINDONE : "/simple-api/w/ky/bigdata/brand/findOne", // 品牌详情
  KY_BIGDATA_BREED_DELETE : "/simple-api/w/ky/bigdata/brand/delete", // 品牌删除
  KY_YEAR_TIMEALL : "/simple-api/w/ky/bigdata/year/timeAll", // 年列表
  KY_YEAR_TIMEAXISINIT : "/simple-api/w/ky/bigdata/year/timeAxisInit", // 年初始化
  KY_YEAR_TIMEAXISSAVE : "/simple-api/w/ky/bigdata/year/timeAxisSave", // 年保存
  KY_BIGDATA_INDUSTRY_FINDINFO : "/simple-api/w/ky/bigdata/industry/findInfo", // 产业园信息详情
  KY_BIGDATA_INDUSTRY_SAVEORUPDATE : "/simple-api/w/ky/bigdata/industry/saveOrUpdate", // 产业园信息新增修改

  
  

  

  
};
module.exports = Api;
